import React from 'react';

const SVG = ({
  style = {},
  fill = '#000',
  viewBox = '0 0 24 23.447',
  width = '100%',
  className = '',
  height = '100%',
  ...rest
}) => (
  <svg
    width={width}
    style={style}
    height={height}
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    viewBox={viewBox}
    xmlnsXlink="http://www.w3.org/1999/xlink"
    {...rest}
  >
    <g transform="translate(0 -242.4)">
      <path
        fill={fill}
        d="M23.064 2.784h-2.952v-.72A2.059 2.059 0 0 0 18.072 0h-1.1A2.064 2.064 0 0 0 14.9 2.064v.72H9.048v-.72A2.064 2.064 0 0 0 6.984 0H5.88a2.064 2.064 0 0 0-2.064 2.064v.72H.936A.922.922 0 0 0 0 3.72v18.792a.922.922 0 0 0 .936.936h22.128a.922.922 0 0 0 .936-.936V3.72a.922.922 0 0 0-.936-.936zm-6.24-.72a.164.164 0 0 1 .168-.168h1.1a.164.164 0 0 1 .168.168v3.312a.164.164 0 0 1-.168.168h-1.1a.164.164 0 0 1-.168-.168zm-11.064 0a.164.164 0 0 1 .168-.164h1.1a.164.164 0 0 1 .168.168v3.308a.164.164 0 0 1-.168.168h-1.1a.164.164 0 0 1-.168-.168zM1.872 21.576v-11.4h20.256v11.4zM22.128 8.3H1.872V4.656h2.016v.72A2.064 2.064 0 0 0 5.952 7.44h1.1A2.064 2.064 0 0 0 9.12 5.376v-.72h5.856v.72A2.064 2.064 0 0 0 17.04 7.44h1.1a2.064 2.064 0 0 0 2.064-2.064v-.72h2.016V8.3z"
        transform="translate(0 242.4)"
      />
    </g>
  </svg>
);
export default SVG;
